'use client';

import clsx from 'clsx';
import { useState } from 'react';

import { useOutsideClick } from '@/hooks/useClickOutside';
import { useCurrency } from '@/providers/CurrencyProvider';
import styles from './CurrencySwitcher.module.scss';

const availableCurrencies = [
    { code: 'USD', symbol: '$' },
    { code: 'EUR', symbol: '€' },
    { code: 'AED', symbol: 'د.إ' },
    { code: 'JPY', symbol: '¥' },
    { code: 'GBP', symbol: '£' },
] as const;

export function CurrencySwitcher({ className }: { className?: string }) {
    const { currency, setCurrency } = useCurrency();
    const [isOpen, setIsOpen] = useState(false);
    const ref = useOutsideClick(() => setIsOpen(false));

    const currentOption = availableCurrencies.find(opt => opt.code === currency);
    const currentSymbol = currentOption?.symbol ?? '';

    return (
        <div
            ref={ref}
            onClick={() => setIsOpen(!isOpen)}
            className={clsx(styles.root, className, {
                [styles.open]: isOpen,
            })}
        >
            <div className={clsx(styles.wrapper)}>
                <div className={styles.currentLang}>
                    {currentSymbol} {currency}
                </div>

                <div className={clsx(styles.contentWrapper)}>
                    {availableCurrencies.map(({ code, symbol }) => (
                        <div
                            key={code}
                            onClick={() => setCurrency(code)}
                            className={styles.link}
                        >
                            {symbol} {code}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
